
import React from 'react';

export const CicleLoader = (props) => {
    return <div className="content-loader animate"></div>
}
